<template>
  <div class="wrapper flex center column">
    <div class="box">
      <h2 class="previewTitle">
        <!-- ページタイトル（異体字注意点） -->
        <div class="box">
          異体字注意点 - {{ title }} {{ computedPageInfo }}
        </div>
      </h2>
    </div>
    <div class="box grow img-wrapper">
      <img
        class="object-fit"
        :src="fileUrl"
      />
    </div>
    <div class="box">
      <p class="comment">
        {{ comment ? `コメント: ${comment}` : "" }}
      </p>
    </div>
  </div>
</template>

<script>
import FileUsecase from "@/usecases/file.usecase";

export default {
  components: {},
  props: {
    index: {
      type: Number,
      default: 0,
    },
    length: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: "",
    },
    comment: {
      type: String,
      default: "",
    },
    src: {
      type: String,
      default: "",
    },
  },
  data () {
    return {
      fileName: null,
      blankOrDirect: null,
      fileUrl: null,
    };
  },
  async mounted () {
    await this.resolve(this.src);
  },
  watch: {
    src: async function (after) {
      await this.resolve(after);
    },
  },
  computed: {
    computedPageInfo: function () {
      const {
        index,
        length,
      } = this;

      const page = index + 1;

      if (length < 2) {
        return "";
      }

      return `${page} / ${length}`;
    },
  },
  methods: {
    async resolve (src) {
      const fileProperties = await usecase.file.getFileProperties([src]);
      this.fileName = fileProperties.fileName[0];
      this.blankOrDirect = fileProperties.blankOrDirect[0];
      this.fileUrl = fileProperties.fileUrl[0];
    },
  },

  /**
   * [beforeCreate description]
   */
  beforeCreate () {
    usecase.file = new FileUsecase();
  },

  /**
   * [beforeDestroy description]
   */
  beforeDestroy () {
    Object.keys(usecase).map(key => {
      delete usecase[key];
    });
  },
};

const usecase = {};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.wrapper {
  height: 100%;

  .box {
    width: 100%;
    max-width: 100%;
  }
}

.previewTitle {
  margin: 1rem 0 1rem 0;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  white-space: normal;
}

.img-wrapper {
  position: relative;
  overflow: hidden;
}

.object-fit {
  max-width: 100%;
}

@media print {
  .previewTitle {
    margin: 0 0 2rem 0;
    font-size: 24px;
    text-align: left;
  }

  .object-fit {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
}
</style>
